import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerMembership } from '../../../../../../../../../../models/membership';
import { CustomerSearchResult } from '../../../../../../../../../../models/customer';
import { OrganizationConfigService } from '../../../../../../../../../../services/organization-config/organization-config.service';
import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { SelectCustomerModalComponent } from '../../../../../../../modals/select-customer-modal/select-customer-modal.component';


@Component({
  selector: 'app-add-group-membership-member-next-bill-date',
  templateUrl: './add-group-membership-member-next-bill-date.component.html',
  styleUrls: ['./add-group-membership-member-next-bill-date.component.css']
})
export class AddGroupMembershipMemberNextBillDateComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public selectedCustomer: CustomerSearchResult | null = null;

  public errorMessage = '';

  private existingMemberCustomerIds: number[];

  private saveClickedSubscription: Subscription;

  constructor(
    public orgConfig: OrganizationConfigService,
    private activeModal: NgbActiveModal,
    private customerService: CustomerService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });

    this.existingMemberCustomerIds = [];
    for (const member of this.membership.all_customers) {
      this.existingMemberCustomerIds.push(member.id);
    }
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  public openSelectCustomerModal() {
    const modalRef = this.modalService.open(SelectCustomerModalComponent);
    modalRef.componentInstance.excludeCustomerIds = this.existingMemberCustomerIds;
    modalRef.componentInstance.submitCallback = (result: CustomerSearchResult) => {
      this.selectedCustomer = result;
    };
  }

  private handleSave() {
    this.errorMessage = '';

    if (this.membership.unlinked_customers.length > 0) {
      this.errorMessage = 'Membership has unlinked members.';
      return;
    }

    if (this.selectedCustomer === null) {
      this.errorMessage = 'Please select a customer to add to the membership.';
      return;
    }

    this.loadingEvent.emit(true);

    this.customerService
      .addGroupMembershipMemberNextBillDate(this.membership.id, this.selectedCustomer.id)
      .then(() => {
        this.savedCallback('Member scheduled to be added.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to add this member to this membership.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }
}
